import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";

const useStyles = makeStyles(() => ({
  /* Regular Popup */
  DialogTitle: {
    "&.MuiDialogTitle-root": {
      backgroundColor: "#023E7D",
      position: "relative",
      padding: "4px 0px 4px 10px",
    },
    "& h2": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      fontSize: "1rem",
    },
  },
  title: {
    color: "#FFFFFF",
  },
  closeIcon: {
    padding: 10,
    color: "#FFFFFF",
    "& svg": {
      height: "18px",
      width: "18px",
    },
  },
  dialogBox: {
    position: "relative",
    borderRadius: "4px",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.15)",
  },
  DialogContent: {
    padding: 15,
    overflowX: "hidden",
  },
}));

const Modal = (props) => {
  const classes = useStyles();
  const {
    title,
    children,
    open,
    handleClose,
    maxWidth,
    className,
    disableDismiss,
    hideClose,
  } = props;
  // Disable focus trap for modals with dropdowns (prospect, edit timesheet) so dropdown search works
  const disableFocusTrap =
    className &&
    (className.includes("prospect-modal") ||
      className.includes("edit-timesheet-modal") ||
      className.includes("efiling-create-modal") ||
      className.includes("efiling-consent-picker-modal") ||
      className.includes("efiling-preview-modal") ||
      className.includes("docusign-send-modal"));
  return (
    <Dialog
      classes={{ paper: classes.dialogBox }}
      open={Boolean(open)}
      onClose={disableDismiss ? undefined : handleClose}
      disableBackdropClick={Boolean(disableDismiss)}
      disableEscapeKeyDown={Boolean(disableDismiss)}
      fullWidth={Boolean(maxWidth)}
      maxWidth={maxWidth && "90vw"}
      className={className || ""}
      disableEnforceFocus={disableFocusTrap}
      disableAutoFocus={disableFocusTrap}
      BackdropProps={{
        style: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        },
      }}
    >
      {title !== null && (
        <DialogTitle className={classes.DialogTitle}>
          {title && <span className={classes.title}>{title}</span>}
          {!hideClose && handleClose && (
            <IconButton
              onClick={handleClose}
              aria-label="close"
              className={classes.closeIcon}
            >
              <CancelOutlinedIcon />
            </IconButton>
          )}
        </DialogTitle>
      )}
      <DialogContent className={classes.DialogContent}>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default Modal;